import request from "../request.js";
import {
  getBeforeDot,
  formatNumberWithUnit,
  handleEmptyValues
} from "@/assets/js/utils.js";
import { handlePrice } from "@/utils";

// 登陆
export const loginReq = (params) => {
  return request
    .post("/api/login", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 查询个股关键数据
export const stockData = (params) => {
  const requestUrl = params.symbol.indexOf("CI") == "-1" ? "/price/stockdata" : "/concept/stockdata";
  return request.post(requestUrl, params).then((res) => {
    const data = res.data;
    const values = {
      symbol: data[0], // 股票代码
      stockCode: getBeforeDot(data[0]), // 股票代码前缀
      stockName: data[1], // 股票名称
      lastPrice: handlePrice(data[8]), // 最新价
      avgPrice: handlePrice(data[9]), // 均价
      changeRate: handlePrice(data[10] * 100), // 涨幅
      change: handlePrice(data[11]), // 涨跌
      preClosePrice: handlePrice(data[4]), // 昨收
      openPrice: handlePrice(data[5]), // 开盘
      highPrice: handlePrice(data[6]), // 最高
      lowPrice: handlePrice(data[7]), // 最低
      volume: formatNumberWithUnit(data[12] / 100), // 成交量
      amount: formatNumberWithUnit(data[13]), // 成交额
      levels5: [
        data[14],
        data[15],
        data[16],
        data[17],
        handlePrice(data[4])
      ],
      limitUp: handlePrice(data[18]), // 涨停
      limitDown: handlePrice(data[19]), // 跌停
      dealSate: data[20], // 交易状态
      circulatingShare: formatNumberWithUnit(data[21]), // 流通股
      capitalization: formatNumberWithUnit(data[22]), // 总股本
      turnoverRate: handlePrice((data[23] * 100)), // 换手率
      flowValue: formatNumberWithUnit(data[24]), // 流通市值
      totalValue: formatNumberWithUnit(data[25]), // 总市值
      peTTM: handlePrice(data[26]), // 市盈率TTM
      pb: handlePrice(data[27]), // 市净率
      epsTTM: handlePrice(data[28]), // 每股收益TTM
      nav: handlePrice(data[29]), // 每股净资产
      roe: handlePrice(data[30]), // 资产收益率ROE
      dar: handlePrice(data[31]), // 资产负债率
      sellVolume: formatNumberWithUnit(data[35]), // 内盘
      buyVolume: formatNumberWithUnit(data[36]), // 外盘
      bid: data[37], // 委买
      ask: data[38], // 委卖
      orderRatio: handlePrice((data[39] * 100)), // 委比
      entrustDiff: data[40], // 委差
      volumeRatio: handlePrice((data[41])), // 量比
      threeMinRise: handlePrice((data[42] * 100)), // 涨速
      stockType: data[43] // 股票类型 0指数 1股票
    };
    handleEmptyValues(values);
    return values;
  });
};

// 查询股票K线
export function getDetailsReq(params) {
  const requestUrl = params.symbol.indexOf("CI") == "-1" ? "/price/deals" : "/concept/deals";
  return request.post(requestUrl, params).then((res) => {
    const data = res.data;
    return data;
  });
}

// 查询个股所属概念
export function stockConceptsReq(params) {
  return request.post("/price/stockconcepts", params).then((res) => {
    const data = res.data[0][6];
    const list = [];
    data.forEach((item, index) => {
      const values = {
        index: item[0],
        symbol: item[1],
        code: getBeforeDot(item[1]),
        stockName: item[2], // 名称
        amplitudeOpen: (item[3] * 100).toFixed(2), // 开幅
        changeRate: (item[4] * 100).toFixed(2), // 涨跌幅
        threeMinRise: (item[5] * 100).toFixed(2), // 涨速
        volumeRatio: item[6].toFixed(2) // 量比
      };
      handleEmptyValues(values);
      list.push(values);
    });
    return list;
  });
}

// 添加股票
export const addStock = (params) => {
  return request
    .post("/api/stockstarrankhistory/stockRengongOrderHistory/add", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 获取模糊查询股票列表
export const getAutoStockList = (params) => {
  return request
    .get(`/api/outsys/stock/getAshareProfileList`, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 查询股票快照
export const getLastPrice = (params) => {
  return request
    .post("/price/lastprice", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 获取行业板块,行业板块,概念板块
// {field: 4, req_num: 6, sort: 2, start: 0, block: "B103"}
export const getIndustryblockdetail = (params) => {
  return request
    .post("/price/industryblockdetail2", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 获取板块列表 B103概念板块，B104行业板块，B105全部
// {field: 4, req_num: 40, sort: 2, start: 0, block: "B103"}
export const getBlockList = (params) => {
  return request
    .post("/price/industryblockdetail", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 获股票数据，沪深A股:B001,创业板:B003,科创板:B004
// 提交数据{field: 7, req_num: 40, sort: 2, start: 0, block: "B004"}
export const getStockblockdetail2 = (params) => {
  return request
    .post("/price/stockblockdetail2", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 获取查询APP轮播图列表
export const selectStockAppCarouselShowList = () => {
  return request
    .get(`/api/outsys/commoncarousel/selectStockAppCarouselShowList`, {
      params: {
        limit: 3
      },
      isLogin: 1
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 获取查询市场行情广度统计数据
export const marketbreadthdata = (params) => {
  return request
    .post("/price/marketbreadthdata", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 添加自选股
export const addOptionalStock = (params, isLogin = 1) => {
  return request
    .get(`/api/stock/stockPoolList/addStockSelectOne`, {
      params,
      isLogin
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 查询自选股 isLogin = 1 401时不弹出登录   isLogin = 2 401时弹出登录
export const getOptionalStockList = (params, isLogin = 1) => {
  return request
    .get(`/api/stock/stockPool/getUserStockSelect`, {
      params,
      isLogin
    })
    .then((res) => {
      return res;
    });
};

// 根据股票代码集合查询股票信息集合
export const getStockInfoByCodes = (params) => {
  return request
    .post("/price/stockblockdetail3", params)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 删除自选股
export const delOptionalStock = (params, isLogin = 1) => {
  return request
    .get(`/api/stock/stockPoolList/deleteStockSelectOne`, {
      params,
      isLogin
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 查询需要加锁的指标列表
export const getTargetTryOut = (params) => {
  return request
    .get(`/api/outsys/commonmethod/selectGnqyIndicatorTrialTimesList`, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 查询当前股票下的指标是否需要加锁
export const checkUserIndicatorPower = (params) => {
  return request
    .get(`/api/gnqy/gnqyIndicatorFlow/checkUserIndicatorPower`, { params })
    .then((res) => {
      return res;
    });
};
// 给指标解锁
export const authUserIndicatorPower = (params) => {
  return request
    .get(`/api/gnqy/gnqyIndicatorFlow/authUserIndicatorPower`, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 获取授权地址
export function getAuthUrl (params) {
  return request
    .get(`/api/auth/wechat/authorize`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 将微信授权后拿到的code给后端  获取用户信息
export function getWeChatUserInfo (params) {
  return request
    .get(`/api/auth/wechat/callback`, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 获取产品列表接口
export function getProductList (params) {
  return request
    .get("/api/user/getUserRelationInfoList")
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 刷新用户信息
export const refreshUserInfo = () => {
  return request
    .get("/api/gn/gnClientCto/refreshClientCto")
    .then((res) => {
      return res;
    });
};

// 获取屏幕共享的sdkAppId
export const getScreenShareSdkAppId = (params) => {
  return request.get("/api/tencent/tencent/getSdkAppID").then((res) => {
    return res;
  });
};

// 获取屏幕共享的userSig
export const getScreenShareUserSig = (params) => {
  return request.get("/api/tencent/tencent/genUserSig").then((res) => {
    return res;
  });
};

// 账号注销
export const accountCancellation = (params) => {
  return request.get("/api/userinfo/userInfoCancellationRecord/userCancellation", { params }).then((res) => {
    return res;
  });
};

// 查询策略池tabs数据
export const getStrategyPoolTabs = (params) => {
  return request.get("/api/outsys/commonmethod/selectLmSelectIndicatorInfoList", { params }).then((res) => {
    if (res.code == 200 && res?.data?.length > 0) {
      const list = res.data.map((item) => {
        return {
          ...item,
          id: item.indicatorId,
          title: item.indicatorName,
          type: item.indicatorType,
        };
      });
      return list;
    }
    return [];
  });
};
// 查询策略池 股票列表
export const getStrategyPoolStockList = (params) => {
  return request.post("/indicator/indicatordetail", params).then((res) => {
    if (res.result?.code == 0 && res.data?.length > 0) {
      const data = res.data[0][8];
      const list = data.map((item) => {
        return {
          index: item[0],
          symbol: item[1], // 股票代码
          stockName: item[2], // 股票名称
          time: item[3], // 信号时间
          changeRate: handlePrice(item[4] * 100), // 涨幅
          lastPrice: handlePrice(item[5]), // 现价
          enterPrice: handlePrice(item[6]), // 进入价
          enterChangeRate: handlePrice(item[7] * 100), // 入选后涨幅
          industry: item[8], // 行业
          concept: item[9], // 概念
        };
      });
      return { list, total: res.data[0][4]};
    }
    return {
      list: [],
      total: 0
    };
  });
};
// 查询策略池 往期数据
export const getStrategyPoolHistoryList = (params) => {
  return request.get("/api/lmtrade/lmIndicatorSelectResult/getLmIndicatorSelectResultList", { params }).then((res) => {
    if (res.code == 200 && res.data.length) {
      const list = res.data.map((item) => {
        return {
          ...item,
          closeIncrease: handlePrice(item.closeIncrease),
          maxIncreaseT1: handlePrice(item.maxIncreaseT1),
          maxIncreaseT3: handlePrice(item.maxIncreaseT3),
          maxIncreaseT7: handlePrice(item.maxIncreaseT7),
          // maxIncreaseT5: handlePrice(item.maxIncreaseT5),
          // maxIncreaseT10: handlePrice(item.maxIncreaseT10),
        };
      });
      return list;
    };
    return [];
  });
};

// 获取交易日列表 不需要登录
export const getLmMktTradeCalList = (params) => {
  return request.get("/api/outsys/commonmethod/getLmMktTradeCalList", { params }).then((res) => {
    if (res.code == 200 && res.data.length) {
      const list = res.data.map((item) => {
        const dateObj = new Date(item.tradingDate);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return {
          ...item,
          date: `${year}/${month}/${day}`,
          month: `${month}-${day}`,
          tradingTime: dateObj.getTime(), // 交易日期时间戳 毫秒
        };
      });
      return list;
    }
    return [];
  });
};

// 查询操作系统的登录方式配置
export const getSystemLoginType = (params) => {
  return request.get("/api/outsys/commonmethod/getLoginTypeConfig", { params }).then((res) => {
    if (res.code == 200 && res.data) {
      return res.data;
    };
    return {};
  });
};



// 产品列表查询合同
export const getProductContract = (params) => {
  return request.post("https://crm.cloudgn.com:9222/api-contractSign/payonline/queryByOrderNo", { params }).then((res) => {
    return res;
  });
};

// 头条中的热点列表
export function getHotList (params) {
  return request
    .get(`https://prod-web.cloudgn.com/news_svc/v1/get_internal_control`, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 首页头条列表
export function getInternalControl (params) {
  return request
    .get(`https://prod-web.cloudgn.com/news_svc/v1/get_internal_control`, {
      params: {
        type: 1,
        page_num: params.page_num,
        page_size: params.page_size
      }
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
}
// 获取头条详细内容
export function getInternalControlDetail (params) {
  const url = params.report_type == 3 ? "https://prod-web.cloudgn.com/news_svc/v1/get_review_detail" : "https://prod-web.cloudgn.com/news_svc/v1/query_report_info";
  const options = params.report_type == 3 ? { qr_id: params.id } : { report_type: params.report_type };
  return request
    .get(url, {
      params: {
        id: params.id,
        ...options
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
}

// 7x24列表 last_time最后一条数据的时间
export function getHighEnergyTeacher (params) {
  return request
    .get(`https://prod-web.cloudgn.com/news_svc/v2/get_shanghai_news_flash`, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
}

// 7x24列表 last_time最后一条数据的时间
export function getGongGaoList (params) {
  return request
    .get(`https://prod-web.cloudgn.com/vip_svc/v1/get_wx_vip_list_pc`, {
      params: {
        type: 1,
        ...params
      }
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
}

// 要闻列表
export function getInformation (params) {
  return request
    .get(`https://prod-web.cloudgn.com/news_svc/v1/get_gnpc_news_list`, {
      params: {
        type: 1,
        ...params
      }
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 要闻详情内容
export function getInformationDetail (params) {
  return request
    .get(`https://prod-web.cloudgn.com/news_svc/v2/get_lian_article`, {
      params: {
        id: params.id
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};

// 获取个股公告
export function getStockNotice (params) {
  return request
    .get(`https://prod-web.cloudgn.com/stock_svc/v1/list_by_stock_code`, {
      params: {
        scode: params.scode,
        page_num: params.page_num,
        page_size: params.page_size
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 获取个股简况>公司概况
// https://prod-web.cloudgn.com/stock_svc/v1/stock_company?stock_id=300651.XSHE
export function getGongSiNotice (params) {
  return request
    .get(`https://prod-web.cloudgn.com/stock_svc/v1/stock_company`, {
      params: {
        stock_id: params.stock_id
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 获取个股简况>操盘必读>最新指标
// https://prod-web.cloudgn.com/stock_svc/v1/timeline?stock_id=300651.XSHE
export function getZhiBiaoNotice (params) {
  return request
    .get(`https://prod-web.cloudgn.com/stock_svc/v1/timeline`, {
      params: {
        stock_id: params.stock_id
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 获取个股简况>操盘必读>大事提醒
// https://prod-web.cloudgn.com/news_svc/v1/query_news_anns?stock_id=300651.XSHE&query_type=2&start_date=20240603&end_date=20250603
export function getDaShiNotice (params) {
  return request
    .get(`https://prod-web.cloudgn.com/news_svc/v1/query_news_anns`, {
      params: {
        stock_id: params.stock_id,
        query_type: 2,
        start_date: params.start_date,
        end_date: params.end_date
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 最新指标
export function finaIndicatorReq (params) {
  return request
    .get(`https://prod-web.cloudgn.com/stock_svc/v1/fina_indicator`, {
      params: {
        stock_id: params.stock_id,
        page: params.page,
        size: params.size
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 资产负债表
export function balancesheetReq (params) {
  return request
    .get(`https://prod-web.cloudgn.com/stock_svc/v1/balancesheet`, {
      params: {
        stock_id: params.stock_id,
        page: params.page,
        size: params.size
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
// 利润表
export const incomeReq = (params) => {
  return request
    .get(`https://prod-web.cloudgn.com/stock_svc/v1/income`, {
      params: {
        stock_id: params.stock_id,
        page: params.page,
        size: params.size
      }
    })
    .then((res) => {
      return res;
    }).catch((error) => {
      console.error(error);
      throw error; // 重新抛出错误以便调用者处理
    });
};
